var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindTurbine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.33 11.67L16.21 14.58C17.62 13.16 16.21 11.75 16.21 11.75L14.72 10.24C14.9 9.86001 15 9.44001 15 9.00001C15 7.95001 14.46 7.03001 13.64 6.50001L15 2.11001C13.09 1.53001 12.5 3.44001 12.5 3.44001L11.69 6.03001C10.46 6.16001 9.45998 7.00001 9.12998 8.18001L4.66998 9.63001C5.30998 11.53 7.19998 10.9 7.19998 10.9L9.26998 10.23C9.60998 10.97 10.23 11.54 11 11.82V19C11 19 8.99998 19 8.99998 21C8.99998 21.5 8.99998 21.81 8.99998 22H15V21C15 21 15 19 13 19V11.82C13.12 11.78 13.23 11.72 13.33 11.67ZM10.5 9.00001C10.5 8.60218 10.658 8.22065 10.9393 7.93935C11.2206 7.65804 11.6022 7.50001 12 7.50001C12.3978 7.50001 12.7793 7.65804 13.0606 7.93935C13.3419 8.22065 13.5 8.60218 13.5 9.00001C13.5 9.39783 13.3419 9.77937 13.0606 10.0607C12.7793 10.342 12.3978 10.5 12 10.5C11.6022 10.5 11.2206 10.342 10.9393 10.0607C10.658 9.77937 10.5 9.39783 10.5 9.00001Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindTurbine);
export default __webpack_public_path__ + "static/media/wind-turbine.0345e558.svg";
export { ForwardRef as ReactComponent };